import Head from 'next/head';
import PropTypes from 'prop-types';

/**
 * Serializes a schema.org object into a safe JSON-LD <script> block.
 *
 * Uses dangerouslySetInnerHTML because React does not support rendering
 * <script type="application/ld+json"> children directly. This is the
 * standard pattern used by next-seo and other SEO libraries.
 *
 * Security: escapeJsonLd replaces `<`, `>`, `&`, and `/` with Unicode
 * escapes per W3C/OWASP recommendations. Prevents `</script>` breakout
 * (XSS) and avoids Rich Results validator issues with stores that have
 * these characters in admin content. The schema object is always built
 * from server-side data (store info, FAQ text stripped of HTML), never
 * from raw user input.
 */

const escapeJsonLd = (obj) =>
  JSON.stringify(obj)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
    .replace(/\//g, '\\u002f');

const SchemaJsonLd = ({ id, schema }) => (
  <Head>
    <script
      dangerouslySetInnerHTML={{ __html: escapeJsonLd(schema) }}
      id={`jsonld-${id}`}
      type="application/ld+json"
    />
  </Head>
);

SchemaJsonLd.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  schema: PropTypes.shape().isRequired,
};

export default SchemaJsonLd;
